import {
  MRC_ACCESSORY,
  MRC_BUYER,
  MRC_FABRIC,
  MRC_FABRIC_PART,
  MRC_GARMENT_ITEM,
  MRC_ITEM_CATEGORY,
  MRC_PROCESS,
  MRC_RATE_TYPE,
  MRC_SEASON,
  MRC_STYLE,
  MRC_TEAM,
} from '@constants/internal-route.constant'
import {useT} from 'utility/useT'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {ADMIN_CONFIG_ROUTES, ITEM_MASTER_ROUTES} from './menu-routes'

// The merchandising navigation, after the client's menu. Children are `gated` (hidden without the feature
// grant), each group is hidden when none of its children survive (menu-routes.ts), and a group's
// pages are listed A–Z by their displayed label (SidebarMenuItemWithSub), so source order here does
// not matter.
//
// A group's `to` is only its open/closed key: every screen shares the /merchandising url prefix (the
// ACL keys), so a group is active by its children's urls (SidebarMenuItemWithSub `anyOf`).
export const SidebarMenuMain = () => {
  const t = useT()

  return (
    <>
      <SidebarMenuItemWithSub
        to='mrc-item-master'
        title={t('MENU.MRC_G_ITEM')}
        fontIcon='bi-box-seam'
        anyOf={ITEM_MASTER_ROUTES}
        defaultOpen
      >
        <SidebarMenuItem gated fontIcon='bi-shop' to={MRC_BUYER} title={t('MENU.MRC_BUYER')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-diagram-2'
          to={MRC_ITEM_CATEGORY}
          title={t('MENU.MRC_ITEM_CATEGORY')}
        />
        <SidebarMenuItem gated fontIcon='bi-layers' to={MRC_FABRIC} title={t('MENU.MRC_FABRIC')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-paperclip'
          to={MRC_ACCESSORY}
          title={t('MENU.MRC_ACCESSORY')}
        />
        <SidebarMenuItem gated fontIcon='bi-palette' to={MRC_STYLE} title={t('MENU.MRC_STYLE')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar3'
          to={MRC_SEASON}
          title={t('MENU.MRC_SEASON')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-tag'
          to={MRC_GARMENT_ITEM}
          title={t('MENU.MRC_GARMENT_ITEM')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-currency-exchange'
          to={MRC_RATE_TYPE}
          title={t('MENU.MRC_RATE_TYPE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-scissors'
          to={MRC_FABRIC_PART}
          title={t('MENU.MRC_FABRIC_PART')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-diagram-3'
          to={MRC_PROCESS}
          title={t('MENU.MRC_PROCESS')}
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='mrc-admin-config'
        title={t('MENU.MRC_G_ADMIN')}
        fontIcon='bi-gear'
        anyOf={ADMIN_CONFIG_ROUTES}
      >
        <SidebarMenuItem gated fontIcon='bi-people' to={MRC_TEAM} title={t('MENU.MRC_TEAM')} />
      </SidebarMenuItemWithSub>
    </>
  )
}
